var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4422 11.4422C11.3841 11.5003 11.3152 11.5464 11.2393 11.5779C11.1635 11.6093 11.0821 11.6255 11 11.6255C10.9179 11.6255 10.8365 11.6093 10.7607 11.5779C10.6848 11.5464 10.6159 11.5003 10.5578 11.4422L1.625 2.50859V9.125C1.625 9.29076 1.55915 9.44973 1.44194 9.56694C1.32473 9.68415 1.16576 9.75 1 9.75C0.83424 9.75 0.675269 9.68415 0.558058 9.56694C0.440848 9.44973 0.375 9.29076 0.375 9.125V1C0.375 0.83424 0.440848 0.675269 0.558058 0.558058C0.675269 0.440848 0.83424 0.375 1 0.375H9.125C9.29076 0.375 9.44973 0.440848 9.56694 0.558058C9.68415 0.675269 9.75 0.83424 9.75 1C9.75 1.16576 9.68415 1.32473 9.56694 1.44194C9.44973 1.55915 9.29076 1.625 9.125 1.625H2.50859L11.4422 10.5578C11.5003 10.6159 11.5464 10.6848 11.5779 10.7607C11.6093 10.8365 11.6255 10.9179 11.6255 11C11.6255 11.0821 11.6093 11.1635 11.5779 11.2393C11.5464 11.3152 11.5003 11.3841 11.4422 11.4422Z",
    fill: "#005596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToIcon);
export default __webpack_public_path__ + "static/media/goToIcon.da65c36f12cbff5175c1deb5ad83caaf.svg";
export { ForwardRef as ReactComponent };